import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '../../design_system/StyledComponents/components/Typography'
import { Close } from '@mui/icons-material'
import { setHelpPopup } from '../../Actions/ApplicationStateAction'
import "./HelpPopup.css"

const HelpPopup = () => {
    const { helpPopup } = useSelector((state) => state.ApplicationState)
    const dispatch = useDispatch()
    const handleClose = () => {
        dispatch(setHelpPopup(false))
    }

    return (
        helpPopup &&
        <div className='help-popup'>
            <div className='help-popup-content'>
                <Typography>Click on the&nbsp;</Typography>
                <Typography className='help-popup-room'>Room</Typography>
                <Typography>&nbsp;name to begin </Typography>
            </div>
            <div className='help-popup-close' onClick={handleClose}>
                <Close />
            </div>
        </div>
    )
}

export default HelpPopup
